var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BContainer',[_c('div',{staticStyle:{"margin-top":"40%"}},[_c('FrForbidden',{attrs:{"show-dashboard":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }